import * as React from 'react';
import {StepProps} from './types';

export default class Step extends React.Component<StepProps, {}> {
  public render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Steps/Step.tsx